import React from "react";
import { Box, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { Guideline } from "../../../api";
import { ColorsEnum } from "../../../common/theme/colors";
import { storageUriToFullUrl } from "../../../utils/storage";
import { getLanguageFlag } from "../../../utils/languageFlags";
import * as S from "../style";

interface GuidelineCardProps {
  guideline: Guideline;
  onClick: () => void;
}

const GuidelineCard: React.FC<GuidelineCardProps> = ({
  guideline: g,
  onClick,
}) => (
  <S.StyledGuidelineCard elevation={1} onClick={onClick}>
    <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
      {g.image_url ? (
        <img
          src={storageUriToFullUrl(g.image_url) || ''}
          width={40}
          height={40}
          alt="guideline"
        />
      ) : (
        <Box sx={S.StyledCardIconBox}>
          <DescriptionIcon
            sx={{ color: ColorsEnum.gunmetal, fontSize: 24 }}
          />
        </Box>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="subtitle2"
          fontWeight={600}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {g.title}
        </Typography>
      </Box>
    </Box>

    {g.description && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mb: 1.5,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          fontSize: "0.85rem",
        }}
      >
        {g.description}
      </Typography>
    )}

    <Box sx={{ flex: 1 }} />
    <Box sx={S.StyledCardMetadataGrid}>
      {g.source_org && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 0.25 }}
          >
            Source
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.8rem", fontWeight: 500 }} noWrap>
            {g.source_org}
          </Typography>
        </Box>
      )}
      {g.language && (
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mb: 0.25 }}
          >
            Language
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.8rem", fontWeight: 500 }} noWrap>
            {getLanguageFlag(g.language)}{getLanguageFlag(g.language) ? ' ' : ''}{g.language.toUpperCase()}
          </Typography>
        </Box>
      )}
    </Box>

    {/* Bottom: Embedded / Chunks counts as small grey text */}
    <Box sx={{ pt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        {g.embedded_count ?? 0} embedded • {g.chunk_count ?? 0} chunk{(g.chunk_count ?? 0) !== 1 ? "s" : ""}
      </Typography>
    </Box>
  </S.StyledGuidelineCard>
);

export default GuidelineCard;
